import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ReportMemberRegistrationPage } from './report-member-registration.page';

const routes: Routes = [
  {
    path: '',
    component: ReportMemberRegistrationPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ReportMemberRegistrationPageRoutingModule {}
